module.exports = __webpack_public_path__ + "img/referral.451bc6df.svg";